import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
    table: {
        background: theme.palette.secondary.light
    },
    campaignDialogContainer: {
        // padding: theme.spacing(3)
    },
    dialogTitle: {
        textAlign: 'center'
    },
    dialogItemInput: {
        padding: theme.spacing(1)
    },
    dialogDateItemInput: {
        padding: theme.spacing(1),
        height: '56px !important'
    },
    dialogSelectItemInput: {
        padding: theme.spacing(1),
        height: '72px !important'
    },
    dialogInputFile: {
        margin: theme.spacing(1),
        border: `.5px solid ${theme.palette.primary.light}`,
    },
    closeIcon: {
        position: 'absolute',
        right: 4,
        top: 4,
        color: theme.palette.grey[700],
        cursor: 'pointer'
    },
    itemInput: {
        width: '100%'
    },
    formControl: {
        minWidth: '100%',
        maxWidth: '100%'
    },
    select: {
        // height: theme.spacing()
    },
    fromInput: {
        // width: '100%',
        height: '40px !important',
        width: '284px !important'
        // paddingLeft: theme.spacing(1),
        // paddingRight: theme.spacing(1)
    },
    descriptionColumn: {
        maxWidth: '250px'
    },
    dialogLogo: {
        marginBottom: '10px',
        height: '200px',
        textAlign: 'center',
        position: 'relative',
        width: 'fit-content',
        margin: '0 auto'
    },
    dialogLogoImg: {
        maxWidth: '100%',
        maxHeight: '200px',
        objectFit: 'cover',
        borderRadius: '4px'
    }
}))

export default useStyles
